import React, { Component } from 'react';
import * as mat from 'material-ui';
import { connect } from 'react-redux';
import hear from './images/hear_icon.png';
import write from './images/write_icon.png';
import speak from './images/speak_icon.png';
import read from './images/read_icon.png';
import FaCheck from 'react-icons/lib/fa/check'
import { FetchDetailsQuiz } from '../action/detailAction';
import firebase from 'firebase';
// import { browserHistory } from 'react-router';
import { scoreViewAction } from '../action/scoresAction'
import dummy from './images/Magelogoorig.png'
import ReactAudioPlayer from 'react-audio-player';
import quizStart from './music/bensound-funkyelement.mp3'
import correctBell from './music/Correct-answer.mp3'
import Timer from './timer.js'
import './style.css'

class QuizQuestion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quizQuestions: [],
            currentQuizIndex: 0,
            nextButton: false,
            gamePinObj: {},
            quizStarts: true,
            correct: false,
            flagforTimer: true

        }
    }
    timeOuts;
    componentWillUpdate(nextProps, nextState) {
        clearTimeout(this.timeOuts)
    }
    componentDidMount() {
        this.props.FetchDetailsQuiz(this.props.currentQuiz.quizTitle);
        this.setState({ gamePinObj: this.props.gameKey })

        let that = this;

        firebase.database().ref('/gameRom/').on('child_changed', function (changeData) {
            if (changeData.val().key === that.props.gameKey.key) {

                that.setState({ gamePinObj: changeData.val() })

                let changedGamePinObj = changeData.val();
                // console.log('88888888888', changedGamePinObj);
                that.setState({ currentQuizIndex: changedGamePinObj.currentQuizIndex })
                let flag = false;
                for (var key in changedGamePinObj.players) {
                    if ('quizSelected' in changedGamePinObj.players[key] === false) {
                        flag = false;
                        break;
                    }
                    else if ('quizSelected' in changedGamePinObj.players[key] === true) {
                        flag = true;
                    }
                }
                // for (var i = 0; i < changedGamePinObj.players.length; i++) {
                //     if ('quizSelected' in changedGamePinObj.players[i] === false) {
                //         flag = false;
                //         break;
                //     }
                //     else if ('quizSelected' in changedGamePinObj.players[i] === true) {
                //         flag = true;
                //     }
                // }
                if (flag === true) {
                    // console.log('true question played');
                    // that.setState({ quizStarts: false })
                    // that.setState({ correct: true })
                    that.setState({
                        nextButton: true,
                        flagforTimer: false,
                        correct: true,
                        quizStarts: false
                    })

                }
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        // console.log(nextProps.quizQuestions, 'adsfdasfadsfadsfasdf');
        // if (this.state.quizQuestions.length && this.state.quizQuestions.length > 0) {
        //     let timeToEnd = this.state.quizQuestions[this.state.currentQuizIndex]['time'];
        //     timeToEnd = timeToEnd.replace(' Sec', '');
        //     // console.log((Number(timeToEnd) + 10) * 1000, 'ddddddddddd', timeToEnd);
        // }



        if (nextProps.quizQuestions !== {} && nextProps.quizQuestions !== undefined && nextProps.quizQuestions !== null) {
            function randomNumberGenerator(min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min
            }
            const range = []

            while (range.length < (3 - 0 + 1)) {
                var randomNumber = randomNumberGenerator(0, 3)

                if (range.indexOf(randomNumber) === -1) {
                    range.push(randomNumber)
                }
            }
            let questionsArrey = nextProps.quizQuestions;
            for (var k = 0; k < questionsArrey.length; k++) {
                let questionNumber = questionsArrey[k];
                // console.log(questionNumber, 'questionNumber', range);
                let questionObject = {
                    imgUrl: questionNumber.imgUrl,
                    questions: questionNumber.questions,
                    time: questionNumber.time,
                    titles: questionNumber.titles
                }
                for (var i = 0; i < range.length; i++) {
                    if (range[i] === 0) {
                        if (i === 0) {
                            questionNumber.answer1.optionName = 'a';
                            questionNumber.answer1.bgColor = '#9D1716';
                            questionNumber.answer1.icon = read;

                            questionObject.answer1 = questionNumber.answer1;

                        }
                        else if (i === 1) {
                            questionNumber.answer2.optionName = 'a';
                            questionNumber.answer2.bgColor = '#612F90';
                            questionNumber.answer2.icon = write;

                            questionObject.answer1 = questionNumber.answer2;
                        }
                        else if (i === 2) {
                            questionNumber.answer3.optionName = 'a';
                            questionNumber.answer3.bgColor = '#5E9134';
                            questionNumber.answer3.icon = speak;

                            questionObject.answer1 = questionNumber.answer3;
                        }
                        else if (i === 3) {
                            questionNumber.answer4.optionName = 'a';
                            questionNumber.answer4.bgColor = '#DEC629';
                            questionNumber.answer4.icon = hear;

                            questionObject.answer1 = questionNumber.answer4;
                        }
                    }
                    else if (range[i] === 1) {
                        if (i === 0) {
                            questionNumber.answer1.optionName = 'b';
                            questionNumber.answer1.icon = read;

                            questionNumber.answer1.bgColor = '#9D1716';
                            questionObject.answer2 = questionNumber.answer1;
                        }
                        else if (i === 1) {
                            questionNumber.answer2.optionName = 'b';
                            questionNumber.answer2.icon = write;

                            questionNumber.answer2.bgColor = '#612F90';

                            questionObject.answer2 = questionNumber.answer2;
                        }
                        else if (i === 2) {
                            questionNumber.answer3.optionName = 'b';
                            questionNumber.answer3.bgColor = '#5E9134';
                            questionNumber.answer3.icon = speak;

                            questionObject.answer2 = questionNumber.answer3;
                        }
                        else if (i === 3) {
                            questionNumber.answer4.optionName = 'b';
                            questionNumber.answer4.bgColor = '#DEC629';
                            questionNumber.answer4.icon = hear;

                            questionObject.answer2 = questionNumber.answer4;
                        }
                    }
                    else if (range[i] === 2) {
                        if (i === 0) {
                            questionNumber.answer1.optionName = 'c';
                            questionNumber.answer1.icon = read;

                            questionNumber.answer1.bgColor = '#9D1716';

                            questionObject.answer3 = questionNumber.answer1;
                        }
                        else if (i === 1) {
                            questionNumber.answer2.optionName = 'c';
                            questionNumber.answer2.bgColor = '#612F90';
                            questionNumber.answer2.icon = write;

                            questionObject.answer3 = questionNumber.answer2;
                        }
                        else if (i === 2) {
                            questionNumber.answer3.optionName = 'c';
                            questionNumber.answer3.bgColor = '#5E9134';
                            questionNumber.answer3.icon = speak;

                            questionObject.answer3 = questionNumber.answer3;
                        }
                        else if (i === 3) {
                            questionNumber.answer4.optionName = 'c';
                            questionNumber.answer4.bgColor = '#DEC629';
                            questionNumber.answer4.icon = hear;

                            questionObject.answer3 = questionNumber.answer4;
                        }
                    }
                    else if (range[i] === 3) {
                        if (i === 0) {
                            questionNumber.answer1.optionName = 'd';
                            questionNumber.answer1.icon = read;

                            questionNumber.answer1.bgColor = '#9D1716';

                            questionObject.answer4 = questionNumber.answer1;
                        }
                        else if (i === 1) {
                            questionNumber.answer2.optionName = 'd';
                            questionNumber.answer2.bgColor = '#612F90';
                            questionNumber.answer2.icon = write;

                            questionObject.answer4 = questionNumber.answer2;
                        }
                        else if (i === 2) {
                            questionNumber.answer3.optionName = 'd';
                            questionNumber.answer3.bgColor = '#5E9134';
                            questionNumber.answer3.icon = speak;

                            questionObject.answer4 = questionNumber.answer3;
                        }
                        else if (i === 3) {
                            questionNumber.answer4.optionName = 'd';
                            questionNumber.answer4.bgColor = '#DEC629';
                            questionNumber.answer4.icon = hear;

                            questionObject.answer4 = questionNumber.answer4;
                        }
                    }
                }

                questionsArrey[k] = questionObject;
                if ('correctSequence' in questionNumber) {
                    questionsArrey[k].correctSequence = questionNumber.correctSequence
                }

                console.log(questionsArrey, 'aaaa')
            }
            this.setState({
                quizQuestions: questionsArrey,
                // flagforTimer: true
            })
        }
        else {
            this.setState({
                quizQuestions: nextProps.quizQuestions,
                // flagforTimer: true
            })
        }
    }
    nextQuestion() {
        // console.log(this.state.gamePinObj, 'fdsafadsfadsfadsfadsfas');
        let gameKeyClone = this.state.gamePinObj;
        let playersClone = this.state.gamePinObj.players;
        gameKeyClone.currentQuizIndex = +gameKeyClone.currentQuizIndex + 1;
        for (var key in playersClone) {
            let currentQuizPlayer = playersClone[key];
            delete currentQuizPlayer.quizSelected;
        }

        // delete playersClone.players;
        // for (var i = 0; i < playersClone.length; i++) {
        //     let currentQuizPlayer = playersClone[i];
        //     delete currentQuizPlayer.quizSelected;
        // }
        // console.log(gameKeyClone, 'gameKeyClonegameKeyClonegameKeyClone');
        firebase.database().ref('/gameRom/' + gameKeyClone.key + '/').set(gameKeyClone);
        this.setState({
            currentQuizIndex: gameKeyClone.currentQuizIndex,
            correct: false,
            nextButton: false,
            quizStarts: true,
            flagforTimer: true
        })
    }

    viewScore() {
        // console.log('view score clicked');
        let gameKeyClone = this.state.gamePinObj;
        let playersClone = this.state.gamePinObj.players;
        // delete playersClone.players;
        for (var i = 0; i < playersClone.length; i++) {
            let currentQuizPlayer = playersClone[i];
            delete currentQuizPlayer.quizSelected;
        }
        // console.log(gameKeyClone, 'gameKeyClonegameKeyClonegameKeyClone');
        gameKeyClone.showScore = true;
        this.setState({
            currentQuizIndex: gameKeyClone.currentQuizIndex,
            nextButton: false,
            flagforTimer: false

        })
        this.props.scoreViewAction(gameKeyClone)

    }
    render() {
        // if (this.state.quizQuestions.length && this.state.quizQuestions.length > 0) {
        //     let timeToEnd = this.state.quizQuestions[this.state.currentQuizIndex]['time'];
        //     timeToEnd = timeToEnd.replace(' Sec', '');
        //     // console.log((timeToEnd + 10) * 1000, 'ddddddddddd', timeToEnd);
        //     let that = this;
        //     that.timeOuts = setTimeout(() => {
        //         // console.log(this, 'called assync', (timeToEnd + 10) * 1000)
        //         that.setState({ quizStarts: false })
        //         that.setState({ correct: true })
        //         that.setState({ nextButton: true })
        //     }, (Number(timeToEnd)) * 1000)
        // }
        return (
            <div>
                <mat.Card
                    zDepth={0}
                    className='container'
                >
                    {(this.state.quizStarts === true) ? (
                        <ReactAudioPlayer
                            src={quizStart}
                            autoPlay={true}
                            controls={false}
                        />
                    ) :
                        (
                            <ReactAudioPlayer
                                src={correctBell}
                                autoPlay={true}
                                controls={false}
                            />
                        )}

                    {
                        (this.state.flagforTimer === true) ? (
                            <div className='col-md-2 col-xs-3' className='timeer'>
                                <div className='round'>
                                    <h1 className='timerText'>
                                        {(this.state.flagforTimer === true && this.state.quizQuestions && this.state.quizQuestions.length > 0 && this.state.quizQuestions[this.state.currentQuizIndex]['time']) ? (
                                            <Timer TimerToStart={this.state.quizQuestions[this.state.currentQuizIndex]['time']} currentState={this} />
                                        ) : 0}
                                    </h1>
                                </div>
                            </div>
                        ) : null
                    }
                    {(this.state.quizQuestions.length > 0 && this.state.currentQuizIndex !== undefined && this.state.currentQuizIndex + 1 !== this.state.quizQuestions.length) ? (
                        <div className='col-md-8 col-md-offset-2 col-xs-10 col-xs-offset-1'>
                            <div className="page-header text-center ">
                                <p style={{ fontSize: '5.5vh', fontFamily: 'arial', fontWeight: 'bold' }}>
                                    {this.state.quizQuestions[this.state.currentQuizIndex].questions}
                                </p>
                            </div>

                            <div style={{ marginBottom: '2%' }}>
                                {
                                    (this.state.nextButton === true) ?
                                        (
                                            <div className='text-right'>
                                                <mat.RaisedButton
                                                    onClick={this.nextQuestion.bind(this)}
                                                    label='Next'
                                                    secondary={true}
                                                    labelStyle={{ color: '#ffffff' }}
                                                />
                                            </div>

                                        ) : (
                                            <div className='text-right'>
                                                <mat.RaisedButton
                                                    label='Next'
                                                    disabled={true}
                                                    secondary={true}
                                                    labelStyle={{ color: '#ffffff' }}
                                                />
                                            </div>
                                        )
                                }
                            </div>
                            <div className='text-center' style={{ marginBottom: '1%', height: 275 }}>
                                {(this.state.quizQuestions[this.state.currentQuizIndex].imgUrl === 'https') ? (
                                    <img style={{ width: '80%', height: 270 }} src={dummy} alt='img' />
                                ) : (
                                        <img style={{ width: '80%', height: 270 }} src={this.state.quizQuestions[this.state.currentQuizIndex].imgUrl} alt='img' />

                                    )}
                            </div>
                            <div className='col-md-12 col-xs-12 '>
                                {(this.state.quizQuestions[this.state.currentQuizIndex].correctSequence === undefined) ? (
                                    <div className='row'>
                                        <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                            {(this.state.correct === true && this.state.quizQuestions[this.state.currentQuizIndex].answer1.correctAns === true) ? (
                                                <mat.List style={{ backgroundColor: '#29d730' }}>
                                                    <mat.ListItem
                                                        leftAvatar={
                                                            <mat.Avatar backgroundColor={'#29d730'} icon={<FaCheck style={{ color: '#ffffff' }} />} />
                                                        }
                                                        primaryText={
                                                            <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                {this.state.quizQuestions[this.state.currentQuizIndex].answer1.value}
                                                            </span>
                                                        }
                                                    />
                                                </mat.List >
                                            ) : (
                                                    <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer1.bgColor }}>
                                                        <mat.ListItem
                                                            leftAvatar={
                                                                <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer1.bgColor} icon={<img src={(this.state.quizQuestions[this.state.currentQuizIndex].answer1.icon)} alt='asd' style={{ width: '80%' }} />} />
                                                            }
                                                            primaryText={
                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer1.value}
                                                                </span>
                                                            }
                                                        />
                                                    </mat.List >

                                                )}
                                        </div>
                                        <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                            {(this.state.correct === true && this.state.quizQuestions[this.state.currentQuizIndex].answer2.correctAns === true) ? (
                                                <mat.List style={{ backgroundColor: '#29d730' }}>
                                                    <mat.ListItem
                                                        leftAvatar={
                                                            <mat.Avatar backgroundColor={'#29d730'} icon={<FaCheck style={{ color: '#ffffff' }} />} />
                                                        }
                                                        primaryText={
                                                            <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                {this.state.quizQuestions[this.state.currentQuizIndex].answer2.value}
                                                            </span>
                                                        }
                                                    />
                                                </mat.List >
                                            ) : (
                                                    <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer2.bgColor }}>
                                                        <mat.ListItem
                                                            leftAvatar={
                                                                <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer2.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer2.icon} alt='asd' style={{ width: '80%' }} />} />
                                                            }
                                                            primaryText={

                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer2.value}
                                                                </span>
                                                            }
                                                        />
                                                    </mat.List >
                                                )}
                                        </div>
                                    </div>
                                ) : (
                                        <div className='row'>
                                            <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                {(this.state.correct === true) ? (
                                                    <mat.List style={{ backgroundColor: '#9e1616' }}>
                                                        <mat.ListItem
                                                            leftAvatar={
                                                                <mat.Avatar backgroundColor={'#29d730'} icon={<span style={{ marginTop: '50%', fontSize: 24, textAlign: 'center', fontWeight: 'bold' }}>{
                                                                    <span>{this.state.quizQuestions[this.state.currentQuizIndex].correctSequence.indexOf(this.state.quizQuestions[this.state.currentQuizIndex].answer1.value) + 1}</span>
                                                                }</span>} />
                                                            }
                                                            primaryText={
                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer1.value}
                                                                </span>
                                                            }
                                                        />
                                                    </mat.List >
                                                ) : (
                                                        <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer1.bgColor }}>
                                                            <mat.ListItem
                                                                leftAvatar={
                                                                    <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer1.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer1.icon} alt='asd' style={{ width: '80%' }} />} />
                                                                }
                                                                primaryText={
                                                                    <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                        {this.state.quizQuestions[this.state.currentQuizIndex].answer1.value}
                                                                    </span>
                                                                }
                                                            />
                                                        </mat.List >

                                                    )}
                                            </div>
                                            <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                {(this.state.correct === true) ? (
                                                    <mat.List style={{ backgroundColor: '#612f90' }}>
                                                        <mat.ListItem
                                                            leftAvatar={
                                                                <mat.Avatar backgroundColor={'#29d730'} icon={<span style={{ marginTop: '50%', fontSize: 24, textAlign: 'center', fontWeight: 'bold' }}>
                                                                    <span>{this.state.quizQuestions[this.state.currentQuizIndex].correctSequence.indexOf(this.state.quizQuestions[this.state.currentQuizIndex].answer2.value) + 1}</span>
                                                                </span>} />
                                                            }
                                                            primaryText={
                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer2.value}
                                                                </span>
                                                            }
                                                        />
                                                    </mat.List >
                                                ) : (
                                                        <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer2.bgColor }}>
                                                            <mat.ListItem
                                                                leftAvatar={
                                                                    <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer2.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer2.icon} alt='asd' style={{ width: '80%' }} />} />
                                                                }
                                                                primaryText={

                                                                    <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                        {this.state.quizQuestions[this.state.currentQuizIndex].answer2.value}
                                                                    </span>
                                                                }
                                                            />
                                                        </mat.List >
                                                    )}
                                            </div>
                                        </div>
                                    )}

                            </div>
                            <div className='col-md-12 col-xs-12 '>
                                {(this.state.quizQuestions[this.state.currentQuizIndex].correctSequence === undefined) ? (
                                    <div className='row'>
                                        <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                            {
                                                (this.state.correct === true && this.state.quizQuestions[this.state.currentQuizIndex].answer3.correctAns === true) ? (
                                                    <mat.List style={{ backgroundColor: '#29d730' }}>
                                                        <mat.ListItem
                                                            leftAvatar={
                                                                <mat.Avatar backgroundColor={'#29d730'} icon={<FaCheck style={{ color: '#ffffff' }} />} />
                                                            }
                                                            primaryText={

                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer3.value}
                                                                </span>
                                                            }
                                                        />
                                                    </mat.List >
                                                ) : (
                                                        <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer3.bgColor }}>
                                                            <mat.ListItem
                                                                leftAvatar={
                                                                    <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer3.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer3.icon} alt='asd' style={{ width: '80%' }} />} />
                                                                }
                                                                primaryText={

                                                                    <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                        {this.state.quizQuestions[this.state.currentQuizIndex].answer3.value}
                                                                    </span>
                                                                }
                                                            />
                                                        </mat.List >
                                                    )}
                                        </div>
                                        <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                            {(this.state.correct === true && this.state.quizQuestions[this.state.currentQuizIndex].answer4.correctAns === true) ? (
                                                <mat.List style={{ backgroundColor: '#29d730' }}>
                                                    <mat.ListItem
                                                        leftAvatar={
                                                            <mat.Avatar backgroundColor={'#29d730'} icon={<FaCheck style={{ color: '#ffffff' }} />} />
                                                        }
                                                        primaryText={

                                                            <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                {this.state.quizQuestions[this.state.currentQuizIndex].answer4.value}
                                                            </span>
                                                        }
                                                    />
                                                </mat.List >
                                            ) : (
                                                    <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer4.bgColor }}>
                                                        <mat.ListItem
                                                            leftAvatar={
                                                                <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer4.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer4.icon} alt='asd' style={{ width: '80%' }} />} />
                                                            }
                                                            primaryText={

                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer4.value}
                                                                </span>
                                                            }
                                                        />
                                                    </mat.List >
                                                )}
                                        </div>
                                    </div>
                                ) : (
                                        <div className='row'>
                                            <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                {(this.state.correct === true) ? (
                                                    <mat.List style={{ backgroundColor: '#5f9035' }}>
                                                        <mat.ListItem
                                                            leftAvatar={
                                                                <mat.Avatar backgroundColor={'#29d730'} icon={<span style={{ marginTop: '50%', fontSize: 24, textAlign: 'center', fontWeight: 'bold' }}>
                                                                    <span>{this.state.quizQuestions[this.state.currentQuizIndex].correctSequence.indexOf(this.state.quizQuestions[this.state.currentQuizIndex].answer3.value) + 1}</span>
                                                                </span>} />
                                                            }
                                                            primaryText={
                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer3.value}
                                                                </span>
                                                            }
                                                        />
                                                    </mat.List >
                                                ) : (
                                                        <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer3.bgColor }}>
                                                            <mat.ListItem
                                                                leftAvatar={
                                                                    <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer3.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer3.icon} alt='asd' widht={{ widht: '80%' }} />} />
                                                                }
                                                                primaryText={
                                                                    <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                        {this.state.quizQuestions[this.state.currentQuizIndex].answer3.value}
                                                                    </span>
                                                                }
                                                            />
                                                        </mat.List >

                                                    )}
                                            </div>
                                            <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                {(this.state.correct === true) ? (
                                                    <mat.List style={{ backgroundColor: '#e0c530' }}>
                                                        <mat.ListItem
                                                            leftAvatar={
                                                                <mat.Avatar backgroundColor={'#29d730'} icon={<span style={{ marginTop: '50%', fontSize: 24, textAlign: 'center', fontWeight: 'bold' }}>
                                                                    <span>{this.state.quizQuestions[this.state.currentQuizIndex].correctSequence.indexOf(this.state.quizQuestions[this.state.currentQuizIndex].answer4.value) + 1}</span>
                                                                </span>} />
                                                            }
                                                            primaryText={
                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer4.value}
                                                                </span>
                                                            }
                                                        />
                                                    </mat.List >
                                                ) : (
                                                        <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer4.bgColor }}>
                                                            <mat.ListItem
                                                                leftAvatar={
                                                                    <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer4.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer4.icon} alt='asd' style={{ width: '90%' }} />} />
                                                                }
                                                                primaryText={

                                                                    <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                        {this.state.quizQuestions[this.state.currentQuizIndex].answer4.value}
                                                                    </span>
                                                                }
                                                            />
                                                        </mat.List >
                                                    )}
                                            </div>
                                        </div>
                                    )}
                            </div>
                        </div>

                    ) : (
                            <div>
                                {
                                    (this.state.quizQuestions.length > 0 && this.state.currentQuizIndex !== undefined) ? (
                                        <div className='col-md-8 col-md-offset-2 col-xs-10 col-xs-offset-1'>
                                            <div className="page-header text-center ">
                                                <p style={{ fontSize: '5.5vh', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                    {this.state.quizQuestions[this.state.currentQuizIndex].questions}
                                                </p>
                                            </div>
                                            <div style={{ marginBottom: '2%' }}>
                                                {
                                                    (this.state.nextButton === true) ?
                                                        (
                                                            <div className='text-right'>
                                                                <mat.RaisedButton
                                                                    onClick={this.viewScore.bind(this)}
                                                                    label='View Score'
                                                                    primary={true}
                                                                    labelStyle={{ color: '#ffffff' }}
                                                                />
                                                            </div>

                                                        ) : (
                                                            <div className='text-right'>
                                                                <mat.RaisedButton
                                                                    label='View Score'
                                                                    disabled={true}
                                                                    secondary={true}
                                                                    labelStyle={{ color: '#ffffff' }}
                                                                />
                                                            </div>
                                                        )
                                                }
                                            </div>
                                            <div className='text-center' style={{ marginBottom: '1%', height: 275 }}>
                                                {(this.state.quizQuestions[this.state.currentQuizIndex].imgUrl === 'https') ? (
                                                    <img style={{ width: '80%', height: 270 }} src={dummy} alt='img' />
                                                ) : (
                                                        <img style={{ width: '80%', height: 270 }} src={this.state.quizQuestions[this.state.currentQuizIndex].imgUrl} alt='img' />

                                                    )}
                                            </div>
                                            <div className='col-md-12 col-xs-12 '>
                                                {(this.state.quizQuestions[this.state.currentQuizIndex].correctSequence === undefined) ? (
                                                    <div className='row'>
                                                        <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                            {(this.state.correct === true && this.state.quizQuestions[this.state.currentQuizIndex].answer1.correctAns === true) ? (
                                                                <mat.List style={{ backgroundColor: '#29d730' }}>
                                                                    <mat.ListItem
                                                                        leftAvatar={
                                                                            <mat.Avatar backgroundColor={'#29d730'} icon={<FaCheck style={{ color: '#ffffff' }} />} />
                                                                        }
                                                                        primaryText={
                                                                            <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                {this.state.quizQuestions[this.state.currentQuizIndex].answer1.value}
                                                                            </span>
                                                                        }
                                                                    />
                                                                </mat.List >
                                                            ) : (
                                                                    <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer1.bgColor }}>
                                                                        <mat.ListItem
                                                                            leftAvatar={
                                                                                <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer1.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer1.icon} alt='asd' style={{ width: '80%' }} />} />
                                                                            }
                                                                            primaryText={
                                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer1.value}
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </mat.List >

                                                                )}
                                                        </div>
                                                        <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                            {(this.state.correct === true && this.state.quizQuestions[this.state.currentQuizIndex].answer2.correctAns === true) ? (
                                                                <mat.List style={{ backgroundColor: '#29d730' }}>
                                                                    <mat.ListItem
                                                                        leftAvatar={
                                                                            <mat.Avatar backgroundColor={'#29d730'} icon={<FaCheck style={{ color: '#ffffff' }} />} />
                                                                        }
                                                                        primaryText={
                                                                            <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                {this.state.quizQuestions[this.state.currentQuizIndex].answer2.value}
                                                                            </span>
                                                                        }
                                                                    />
                                                                </mat.List >
                                                            ) : (
                                                                    <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer2.bgColor }}>
                                                                        <mat.ListItem
                                                                            leftAvatar={
                                                                                <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer2.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer2.icon} alt='asd' style={{ width: '80%' }} />} />
                                                                            }
                                                                            primaryText={

                                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer2.value}
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </mat.List >
                                                                )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                        <div className='row'>
                                                            <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                                {(this.state.correct === true) ? (
                                                                    <mat.List style={{ backgroundColor: '#9e1616' }}>
                                                                        <mat.ListItem
                                                                            leftAvatar={
                                                                                <mat.Avatar backgroundColor={'#29d730'} icon={<span style={{ marginTop: '50%', fontSize: 24, textAlign: 'center', fontWeight: 'bold' }}>{
                                                                                    <span>{this.state.quizQuestions[this.state.currentQuizIndex].correctSequence.indexOf(this.state.quizQuestions[this.state.currentQuizIndex].answer1.value) + 1}</span>
                                                                                }</span>} />
                                                                            }
                                                                            primaryText={
                                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer1.value}
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </mat.List >
                                                                ) : (
                                                                        <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer1.bgColor }}>
                                                                            <mat.ListItem
                                                                                leftAvatar={
                                                                                    <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer1.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer1.icon} alt='asd' style={{ width: '80%' }} />} />
                                                                                }
                                                                                primaryText={
                                                                                    <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                        {this.state.quizQuestions[this.state.currentQuizIndex].answer1.value}
                                                                                    </span>
                                                                                }
                                                                            />
                                                                        </mat.List >

                                                                    )}
                                                            </div>
                                                            <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                                {(this.state.correct === true) ? (
                                                                    <mat.List style={{ backgroundColor: '#612f90' }}>
                                                                        <mat.ListItem
                                                                            leftAvatar={
                                                                                <mat.Avatar backgroundColor={'#29d730'} icon={<span style={{ marginTop: '50%', fontSize: 24, textAlign: 'center', fontWeight: 'bold' }}>
                                                                                    <span>{this.state.quizQuestions[this.state.currentQuizIndex].correctSequence.indexOf(this.state.quizQuestions[this.state.currentQuizIndex].answer2.value) + 1}</span>
                                                                                </span>} />
                                                                            }
                                                                            primaryText={
                                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer2.value}
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </mat.List >
                                                                ) : (
                                                                        <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer2.bgColor }}>
                                                                            <mat.ListItem
                                                                                leftAvatar={
                                                                                    <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer2.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer2.icon} alt='asd' style={{ width: '80%' }} />} />
                                                                                }
                                                                                primaryText={

                                                                                    <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                        {this.state.quizQuestions[this.state.currentQuizIndex].answer2.value}
                                                                                    </span>
                                                                                }
                                                                            />
                                                                        </mat.List >
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}

                                            </div>
                                            <div className='col-md-12 col-xs-12 '>
                                                {(this.state.quizQuestions[this.state.currentQuizIndex].correctSequence === undefined) ? (
                                                    <div className='row'>
                                                        <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                            {(this.state.correct === true && this.state.quizQuestions[this.state.currentQuizIndex].answer3.correctAns === true) ? (
                                                                <mat.List style={{ backgroundColor: '#29d730' }}>
                                                                    <mat.ListItem
                                                                        leftAvatar={
                                                                            <mat.Avatar backgroundColor={'#29d730'} icon={<FaCheck style={{ color: '#ffffff' }} />} />
                                                                        }
                                                                        primaryText={

                                                                            <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                {this.state.quizQuestions[this.state.currentQuizIndex].answer3.value}
                                                                            </span>
                                                                        }
                                                                    />
                                                                </mat.List >
                                                            ) : (
                                                                    <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer3.bgColor }}>
                                                                        <mat.ListItem
                                                                            leftAvatar={
                                                                                <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer3.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer3.icon} alt='asd' style={{ width: '80%' }} />} />
                                                                            }
                                                                            primaryText={

                                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer3.value}
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </mat.List >
                                                                )}
                                                        </div>
                                                        <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                            {(this.state.correct === true && this.state.quizQuestions[this.state.currentQuizIndex].answer4.correctAns === true) ? (
                                                                <mat.List style={{ backgroundColor: '#29d730' }}>
                                                                    <mat.ListItem
                                                                        leftAvatar={
                                                                            <mat.Avatar backgroundColor={'#29d730'} icon={<FaCheck style={{ color: '#ffffff' }} />} />
                                                                        }
                                                                        primaryText={

                                                                            <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                {this.state.quizQuestions[this.state.currentQuizIndex].answer4.value}
                                                                            </span>
                                                                        }
                                                                    />
                                                                </mat.List >
                                                            ) : (
                                                                    <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer4.bgColor }}>
                                                                        <mat.ListItem
                                                                            leftAvatar={
                                                                                <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer4.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer4.icon} alt='asd' style={{ width: '80%' }} />} />
                                                                            }
                                                                            primaryText={

                                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer4.value}
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </mat.List >
                                                                )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                        <div className='row'>
                                                            <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                                {(this.state.correct === true) ? (
                                                                    <mat.List style={{ backgroundColor: '#5f9035' }}>
                                                                        <mat.ListItem
                                                                            leftAvatar={
                                                                                <mat.Avatar backgroundColor={'#29d730'} icon={<span style={{ marginTop: '50%', fontSize: 24, textAlign: 'center', fontWeight: 'bold' }}>
                                                                                    <span>{this.state.quizQuestions[this.state.currentQuizIndex].correctSequence.indexOf(this.state.quizQuestions[this.state.currentQuizIndex].answer3.value) + 1}</span>
                                                                                </span>} />
                                                                            }
                                                                            primaryText={
                                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer3.value}
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </mat.List >
                                                                ) : (
                                                                        <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer3.bgColor }}>
                                                                            <mat.ListItem
                                                                                leftAvatar={
                                                                                    <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer3.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer3.icon} alt='asd' widht={{ widht: '80%' }} />} />
                                                                                }
                                                                                primaryText={
                                                                                    <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                        {this.state.quizQuestions[this.state.currentQuizIndex].answer3.value}
                                                                                    </span>
                                                                                }
                                                                            />
                                                                        </mat.List >

                                                                    )}
                                                            </div>
                                                            <div className='col-md-6' style={{ marginBottom: '2%' }}>
                                                                {(this.state.correct === true) ? (
                                                                    <mat.List style={{ backgroundColor: '#e0c530' }}>
                                                                        <mat.ListItem
                                                                            leftAvatar={
                                                                                <mat.Avatar backgroundColor={'#29d730'} icon={<span style={{ marginTop: '50%', fontSize: 24, textAlign: 'center', fontWeight: 'bold' }}>
                                                                                    <span>{this.state.quizQuestions[this.state.currentQuizIndex].correctSequence.indexOf(this.state.quizQuestions[this.state.currentQuizIndex].answer4.value) + 1}</span>
                                                                                </span>} />
                                                                            }
                                                                            primaryText={
                                                                                <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                    {this.state.quizQuestions[this.state.currentQuizIndex].answer4.value}
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </mat.List >
                                                                ) : (
                                                                        <mat.List style={{ backgroundColor: this.state.quizQuestions[this.state.currentQuizIndex].answer4.bgColor }}>
                                                                            <mat.ListItem
                                                                                leftAvatar={
                                                                                    <mat.Avatar backgroundColor={this.state.quizQuestions[this.state.currentQuizIndex].answer4.bgColor} icon={<img src={this.state.quizQuestions[this.state.currentQuizIndex].answer4.icon} alt='asd' style={{ width: '90%' }} />} />
                                                                                }
                                                                                primaryText={

                                                                                    <span style={{ color: '#ffffff', padding: 10, fontSize: '120%', fontFamily: 'arial', fontWeight: 'bold' }}>
                                                                                        {this.state.quizQuestions[this.state.currentQuizIndex].answer4.value}
                                                                                    </span>
                                                                                }
                                                                            />
                                                                        </mat.List >
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )}
                </mat.Card>
            </div>
        )
    }


}
const mapStateToProps = (state) => {
    return {
        // auth: state.authReducers.userDetails,
        AllData: state.authReducers.SharedData,
        quizQuestions: state.DetailReducers.QuizQuestions,
        // successFlag: state.DetailReducers.FavorFlag,
        // errorMessage: state.DetailReducers.FavorError,
        // errorFlag: state.DetailReducers.FavorErrorFlag,
        // FavData: state.DetailReducers.FavoriteQuizData,
        gameKey: state.PlayReducers.playKey,
        currentQuiz: state.PlayReducers.currentQuiz
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        FetchDetailsQuiz: (quizKey) => {
            dispatch(FetchDetailsQuiz(quizKey));
        },
        scoreViewAction: (gameKeyClone) => {
            dispatch(scoreViewAction(gameKeyClone))
        }

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(QuizQuestion);
                // export default MyHome;



// WEBPACK FOOTER //
// ./src/component/quizquestion.js